import { render, staticRenderFns } from "./InstitutionMarker.vue?vue&type=template&id=52be84c4"
import script from "./InstitutionMarker.vue?vue&type=script&lang=ts"
export * from "./InstitutionMarker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports